import React, { useEffect } from "react";
import Chart from "common/components/Chart/Chart";

import { NETWORKGRAPH } from "utils/constants";
import { UseNetworkGraphCommentChart } from "hooks/chart/UseNetworkGraphCommentChart";
import { createPortal } from "react-dom";

const SocialNetworkCommentsChart = ({ data }) => {
    const {
        options: optionsNetworkGraphCommentsChart,
        setOptions: setOptionsNetworkGraphCommentsChart,
        showLoading,
        hideLoading,
        tooltipData,
        setTooltipData,
        tooltipRef,
        handleCloseTooltip,
        containerElement,
    } = UseNetworkGraphCommentChart("", (point) => {
        const { id, comment, datetime, plotY, plotX } = point;
        setTooltipData({
            id,
            comment,
            datetime,
            plotY,
            plotX,
        });
    });

    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            showLoading(); // 🔹 Mostrar loading

            setTimeout(() => {
                setOptionsNetworkGraphCommentsChart({
                    ...optionsNetworkGraphCommentsChart,
                    series: [
                        {
                            ...optionsNetworkGraphCommentsChart.series[0],
                            data: data.links,
                            nodes: data.nodes.map(([user, comment, datetime]) => ({
                                id: user,
                                comment: comment,
                                datetime,
                            })),
                        },
                    ],
                });
                hideLoading();
            }, 100);
        } else {
            setTooltipData(null);
            setOptionsNetworkGraphCommentsChart({
                ...optionsNetworkGraphCommentsChart,
                series: [
                    {
                        ...optionsNetworkGraphCommentsChart.series[0],
                        data: [],
                        nodes: [],
                    },
                ],
            });
        }
    }, [data]);

    return (
        <div style={{ position: "relative" }}>
            <Chart
                options={optionsNetworkGraphCommentsChart}
                type={NETWORKGRAPH}
                onChartReady={(chart) => {
                    showLoading.chartRef = chart;
                }}
            />

            {/* Tooltip manual */}
            {tooltipData &&
                containerElement &&
                createPortal(
                    <div
                        ref={tooltipRef}
                        onClick={handleCloseTooltip}
                        style={{
                            position: "fixed",
                            top: 150,
                            left: 0,
                            backgroundColor: "white",
                            border: "1px solid #ccc",
                            padding: "6px 10px",
                            borderRadius: 4,
                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                            pointerEvents: "auto",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            userSelect: "none",
                            zIndex: 9999,
                            width: 300,
                        }}
                    >
                        <div style={{ whiteSpace: "normal", fontSize: 12 }}>
                            <b>Comentario</b>: {tooltipData.comment}
                            <br />
                            <b>Fecha y hora:</b> {tooltipData.datetime}
                            <br />
                            <b>Usuario:</b> {tooltipData.id}
                        </div>
                    </div>,
                    containerElement
                )}
        </div>
    );
};

export default SocialNetworkCommentsChart;
